import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = (props) => {
  const { pageTitle, breadcrumbsImg, breadcrumbsBg, compact } = props;

  return (
    <div
      className={`breadcrumb__area breadcrumb__plr ${compact ? 'breadcrumb__space--sm' : 'breadcrumb__space'} breadcrumb__bg breadcrumb__overlay p-relative fix`}
      style={{
        backgroundColor: '#ffffff',
      }}
    >
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="breadcrumb__content z-index">
              <h3 className="breadcrumb__title">
                {pageTitle ? pageTitle : 'About Us'}
              </h3>
              <div className="breadcrumb__button">
                <Link to="/">
                  Anasayfa<i className="far fa-angle-right"></i>
                  <span>{pageTitle ? pageTitle : 'Hakkımızda'}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
